// extracted by mini-css-extract-plugin
module.exports = {"header":"MediaBrowserModalHeader_header__9YRmG","backBtn":"MediaBrowserModalHeader_backBtn__T6T_3","buttons":"MediaBrowserModalHeader_buttons__tNOxW"};